export default {
    methods: {
        formatRupiah(angka) {
            if (angka === null) {
                angka = 0
            }
            if (angka !== undefined || angka !== null) {
                //return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(angka);

                let numb = 0;
                let textVal1 = new Intl.NumberFormat('id-ID', {style: 'currency', currency: 'IDR'}).format(angka);
                let textVal2 = new Intl.NumberFormat('id-ID', {style: 'currency', currency: 'IDR'}).format(numb);
                let diff = textVal2.replace("0,00","");
                //let nom = angka<0 ? (textVal1.replace("-"+diff,"(Rp ").replace(" ","")+")") : textVal1;
                let nom = angka<0 ? (textVal1.replace("-"+diff,"(Rp ")+")") : textVal1;
                return nom.replace(",00","")
            }
        },

        formatCurrency(codeCur,angka){
            if (angka === null) {
                angka = 0
            }

            if (codeCur === null || codeCur === undefined || codeCur === ""){
                codeCur = 'IDR';
            }

            if (angka !== undefined || angka !== null) {
                let nom = new Intl.NumberFormat('id-ID', {
                    style: 'currency', currency: codeCur,
                    // dibawah ini untuk mengabaikan pembulatan higga 4 digit dibelakang koma
                    // minimumFractionDigits: 1,
                    // maximumFractionDigits: 4,
                    // minimumSignificantDigits: 1,
                    // maximumSignificantDigits: 4
                }
                ).format(angka);
                return angka<0 ? "("+nom.replace(",00","").replace("-","")+")": nom.replace(",00","")
            }
        },

        customFormatCurrency(codeCur,angka){
            if (angka === null) {
                angka = 0
            }

            if (codeCur === null || codeCur === undefined || codeCur === ""){
                codeCur = 'IDR';
            }

            if (angka !== undefined || angka !== null) {
                let nom = new Intl.NumberFormat('id-ID', {
                    style: 'currency', currency: codeCur,
                    // dibawah ini untuk mengabaikan pembulatan higga 4 digit dibelakang koma
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                    // minimumSignificantDigits: 1,
                    // maximumSignificantDigits: 4
                }
                ).format(angka);
                return angka<0 ? "("+nom.replace(",00","").replace("-","")+")": nom.replace(",00","")
            }
        },

        formatNominal(codeCur, angka) {
            if (angka === null || angka === undefined || angka === '') {
                angka = 0
            }
          
            if (!codeCur) {
                codeCur = 'IDR'
            }

            if (Number(angka) === 0) {
                return '0'
            }
          
            const nom = new Intl.NumberFormat('id-ID', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(Number(angka))
          
            return Number(angka) < 0 ? `(${nom.replace('-', '')})` : nom
        },

        formatCurrencyCode(codeCur,angka){
            if (angka === null) {
                angka = 0
            }
            if (codeCur === null || codeCur === undefined || codeCur === ""){
                codeCur = 'IDR';
            }

            if (angka !== undefined || angka !== null) {
                let tempangka = new Intl.NumberFormat('id-ID', {style: 'currency', currency: codeCur}).format(angka);
                let temprp = new Intl.NumberFormat('id-ID', {style: 'currency', currency: codeCur}).format(0);
                temprp = temprp.replace('0,00','');
                let nom = codeCur + " " + tempangka.replace(temprp,'');
                return nom.replace(",00","")
            }
            
        },

        symbolCurrencyES6(item,type){
            let locals =  'id-ID'

            let result = new Intl.NumberFormat(locals,
            { style: 'currency', currency: item }
            ).format(0);
            
            if(type==0){
                result = result.replace('0,00','').replace('0.00','')
                .replace('0','').replace(/\s/g, '')
            }else{
                result = result.replace('0,00','').replace('0.00','')
                .replace('0','').replace(/\s/g, '')
                    .replace("$","\\$")
            }
            return result
        }

    },
}